const SelectStyles = {            
    control: (styles, state) => ({ 
        ...styles, 
        backgroundColor: 'white',                
        fontSize: '15px',
        lineHeight: '1.5',
        minHeight: '50px',
        borderRadius: '2px',
        border: state.isFocused ? '1px solid #883772!important' : '0',        
        boxShadow: state.isFocused ? '0 0 0 1px #883772' : 'none',
    }),          
    option: (styles, { isDisabled, isSelected, isFocused }) => ({                                        
        ...styles,
        backgroundColor: 
        isDisabled ? null
            : isSelected ? '#883772'
                : isFocused ? '#883772'
                    : 'white',                                        
        color: 
        isDisabled ? null
            : isSelected ? 'white'
                : isFocused ? 'white'
                    : 'black',
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: '#883772',
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: 'white',        
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: 'white',
    }),
    menu: (styles) => ({
        ...styles,
        fontSize: '15px',
        lineHeight: '1.5',
        borderRadius: '2px',
        margin: '4px 0px 0px'
    }),  
    menuList  : (styles) => ({
        ...styles,
        maxHeight: '125px',
    }),  
}

export default SelectStyles;